import React from 'react';
interface Props {
  children: React.ReactNode;
  variant?: 'default' | 'gold' | 'outline' | 'success' | 'pending' | 'invite';
  className?: string;
}
const styles: Record<NonNullable<Props['variant']>, string> = {
  default: 'bg-slate-100 text-slate-700 border-slate-200',
  gold: 'bg-gold/10 text-gold-deep border-gold/30',
  outline: 'bg-transparent text-white/80 border-white/20',
  success: 'bg-emerald-50 text-emerald-700 border-emerald-200',
  pending: 'bg-amber-50 text-amber-700 border-amber-200',
  invite: 'bg-petroleum/10 text-petroleum border-petroleum/30'
};
export function Badge({
  children,
  variant = 'default',
  className = ''
}: Props) {
  return <span className={`inline-flex items-center gap-1.5 px-2.5 py-1 text-[11px] font-medium tracking-wide rounded-sm border ${styles[variant]} ${className}`} data-id="element-651">
      {children}
    </span>;
}